import type { MouseEventHandler, ReactNode } from 'react';
import {
  type InteractiveAtomBaseProps,
  type InteractiveAtomSize,
  fromInteractiveAtomToIconSize,
} from '../utils/InteractiveAtomProps';

export type ChipVariant = 'outline' | 'plain';
export type ChipSize = InteractiveAtomSize;

export const fromChipToIconSize = fromInteractiveAtomToIconSize;

export type ChipProps = Omit<
  InteractiveAtomBaseProps,
  'accent' | 'iconPosition'
> & {
  variant: ChipVariant;
  children?: ReactNode;
  dataTestId?: string;
  selected?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement | HTMLButtonElement>;
  onMouseDown?: MouseEventHandler<HTMLDivElement | HTMLButtonElement>;
  onMouseOver?: MouseEventHandler<HTMLDivElement | HTMLButtonElement>;
  onRemove?: () => void;
};
